export const API = {
    assets: 'assets',
    assetDetails: 'assetDetails',
    assetRetrieval: 'assetRetrieval',
    coworkerPermissions: 'coworkerPermissions',
    coworkerPreferences: 'coworkerPreferences',
    customerDetails: 'customerDetails',
    printers: 'printers',
    favouritePrinterList: 'favouritePrinterList',
    defaultPrinter: 'defaultPrinter',
    barCode: 'barCode',
    shareOrder: 'shareOrder',
    shareQuotation: 'shareQuotation',
    store: 'store',
    storePreferences: 'storePreferences',
    orderMessages: 'orderMessages',
    alignProposal: 'alignProposal',
    timeWindows: 'timeWindows',
    servicePrice: 'servicePrice',
    signRequest: 'signRequest',
    signRequests: 'signRequests',
    accountTemplates: 'accountTemplates',
} as const;
